import { ListItem as e } from "../ListItem/index.js";
import { styled as t } from "styled-components";
const r = t.ul`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`, l = t(e)`
  border-radius: 16px;
`;
export {
  r as Container,
  l as SelectableListItem
};
